import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import { Box, Flex, Icon, Tag, Text, Tooltip } from 'core/components';
import NmsDeviceLink from 'app/components/links/NmsDeviceLink';

const StyledTag = styled(Tag)`
  display: flex;
  font-size: 24px;
  font-weight: bold;
  line-height: 1.2;
  justify-content: center;
  text-align: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  &.bp4-tag {
    padding: 0px 24px;
    height: 59px;
  }

  &.small {
    font-size: 12px;
    height: 24px;
    padding: 0px 8px;
  }
`;

function UnmonitoredIcon(props) {
  const { small } = props;
  const size = small ? 24 : 48;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48" fill="none">
      <path
        fill="#A6AAB2"
        d="M0 7.357A6.857 6.857 0 0 1 6.857.5h34.286A6.86 6.86 0 0 1 48 7.357v34.286a6.863 6.863 0 0 1-6.857 6.857H6.857A6.86 6.86 0 0 1 0 41.643zm27.643 8.572c1.307 0 2.357 1.05 2.357 2.26 0 .922-.525 1.682-1.146 2.111l-6.172 3.707a2.58 2.58 0 0 0-1.253 2.207v1.715A2.565 2.565 0 0 0 24 30.5a2.565 2.565 0 0 0 2.571-2.571v-.258l4.929-3.053c2.26-1.264 3.643-3.707 3.643-6.429 0-4.05-3.354-7.5-7.5-7.5h-6.214c-3.783 0-6.858 3.172-6.858 6.857v.858c0 1.521 1.147 2.571 2.572 2.571s2.571-1.05 2.571-2.571v-.858c0-.846.772-1.714 1.715-1.714zm-3.643 24a3.425 3.425 0 0 0 3.429-3.429A3.425 3.425 0 0 0 24 33.071a3.425 3.425 0 0 0-3.429 3.429A3.425 3.425 0 0 0 24 39.929M7.714 5.643a2.572 2.572 0 1 0 .002 5.144 2.572 2.572 0 0 0-.002-5.144m32.572 5.143a2.565 2.565 0 0 0 2.571-2.572 2.57 2.57 0 0 0-2.571-2.571 2.57 2.57 0 0 0-2.572 2.571 2.565 2.565 0 0 0 2.572 2.572M7.714 38.214a2.57 2.57 0 0 0-2.571 2.572 2.57 2.57 0 0 0 2.571 2.571 2.57 2.57 0 0 0 2.572-2.571 2.57 2.57 0 0 0-2.572-2.572m32.572 5.143a2.565 2.565 0 0 0 2.571-2.571 2.565 2.565 0 0 0-2.571-2.572 2.565 2.565 0 0 0-2.572 2.572 2.565 2.565 0 0 0 2.572 2.571"
      />
    </svg>
  );
}

@inject('$devices')
@observer
class DeviceDetailsStatusTag extends Component {
  renderTooltipContent = () => {
    const { device, $devices } = this.props;
    const reasons = device.get('status_reason.reasons') || [];
    return (
      <Flex flexDirection="column" gap={1} p={1} fontSize={14} maxWidth={375}>
        {reasons.map(({ kind, other_device_id, other_device_status }) => {
          if (kind === 'upstream_device') {
            const otherDevice = $devices.activeDeviceSummariesById[other_device_id];

            return (
              <Box key={`${kind}-${other_device_id}`}>
                <Text>
                  This device is unobservable due to the upstream device{' '}
                  <NmsDeviceLink id={other_device_id}>
                    <Text fontWeight="bold">{otherDevice.device_name}</Text>
                  </NmsDeviceLink>{' '}
                  being <Text fontWeight="bold">{other_device_status}</Text>.
                </Text>
              </Box>
            );
          }

          return null;
        })}
      </Flex>
    );
  };

  render() {
    const { device, small, unavailable } = this.props;

    const hasNmsStatus = device?.get('nms_status');

    if (!device || unavailable || !hasNmsStatus) {
      return (
        <Tooltip content="To see device status, monitor the device with NMS." position="bottom-left">
          <UnmonitoredIcon small={small} />
        </Tooltip>
      );
    }

    const disableTooltip = !device.isUnobservable;

    return (
      <Tooltip
        content={this.renderTooltipContent()}
        hoverCloseDelay={500}
        interactionKind="hover"
        position="bottom-left"
        disabled={disableTooltip}
      >
        <StyledTag className={small ? 'small' : ''} minimal intent={device.statusIntent}>
          {device.isUnobservable && <Icon icon="eye-off" mr={1} iconSize={20} />}
          {device.statusDisplay}
        </StyledTag>
      </Tooltip>
    );
  }
}

export default DeviceDetailsStatusTag;
